export default __webpack_public_path__ + "static/media/empty-box.61a63c91.svg";